function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityReportCompleted = function SvgActivityReportCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.16 22.16"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.08 0a11.08 11.08 0 1 0 11.08 11.08A11.08 11.08 0 0 0 11.08 0ZM9.26 16.84l-4.6-4.6 2-2 2.5 2.56 6-6.47 2.03 1.87Z",
    "data-name": "Layer 1",
    style: {
      fill: "#4ea5b5"
    }
  })));
};
export default SvgActivityReportCompleted;